import CourseStatusBanner from './CourseStatusBanner';
export default CourseStatusBanner;
